import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const MobileWrapper = styled.div`
  margin: 25px 15px;
  
  display: flex;
  flex-direction: column;
  visibility: visible;  
  
  @media (min-width: ${breakpoints.desktop}) {
   display: none;           
  }
  
`;

export const DesktopWrapper = styled.div`
  display: none;
  margin: 0px 0px;
  flex-direction: row;
  background:linear-gradient(#2e2e2e,#8e8d8d);
  
  @media (min-width: ${breakpoints.desktop}) {
   display: flex;                 
  }
  
`;

export const VehicleDetailsContainer = styled.div`
  width: 100%;
  margin: 0;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 30px 0 15px 0;
  }
  
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media (min-width: ${breakpoints.desktop}) {
    flex-direction: column;
  }
`;

export const Seperator = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    padding: 0 15px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  padding: 5px 0;
  // ${(props) => props.left && 'padding-left: 0'}
  // ${(props) => props.right && 'padding-right: 0'}
  
  @media (min-width: ${breakpoints.desktop}) {
    flex-basis: 40%;
    padding: 0 0;
  }
`;

export const ErrorWrapper = styled.div`
  text-align: center;
  
  background:linear-gradient(#982828,#4d1718);
  padding: 5px;
`;

export const ErrorText = styled.p`
  margin: 0;
  text-align: center;
  font-size: 0.8rem;
  color: white;
`;

export const Label = styled.p`
  text-align: left;
  font-weight: lighter;
  margin: 0 0 5px 0;
  font-size: 1.4rem;
  color: white;
`;

export const CheckWrapper = styled.div`
  float: right;
`;

/** Text */
export const Title = styled.h2`
  text-align: left;
  font-weight: lighter;
  margin: 0 0 5px 0;
  font-size: 1rem;
  
  ${(props) => props.seperator && 'color: #bebebe;font-size: 1rem;margin: 10px 0 5px 0px'}
`;

export const SubHeading = styled.p`
  text-align: left;
  margin: 5px 0;
`;

export const PromoImage = styled.img`
  border: 0;
  align-self: center;
  margin: 25px;
`;

export const ButtonWrapper = styled.div`
  flex-direction: column;
  display: flex;
  
  
  @media (min-width: ${breakpoints.desktop}) {
   justify-content: space-between; 
   flex-direction: row;         
  }
`


export const ResetButton = styled.button`
  background-color: transparent;
  font-weight: normal;
`
